import React from 'react';
import { ProductFilter } from '../../../../apis/models/products/res/ProductFilter';
import Typo from '../../../../components/atom/Typo';
import styled from 'styled-components';
import { ReactComponent as CheckIcon } from '../../../../assets/check-fill.svg';
import colors from '../../../../constants/colors.constants';
import strings from '../../../../constants/strings.constants';

export interface FilterItemProps {
  productFilter: ProductFilter;
  selected?: boolean;
  onClick?: (filter: ProductFilter) => void;
}

function FilterItem(props: FilterItemProps) {
  const { productFilter, selected = true, onClick } = props;
  const { isEvent, name, isRecommendProduct } = productFilter;

  const typoType = selected ? 'b-16' : 'm-16';
  return (
    <Wrapper
      $selected={selected}
      onClick={() => {
        if (onClick) onClick(productFilter);
      }}
    >
      <div className="flex-1">
        <div className="flex items-center gap-2">
          <Typo type={typoType}>{name}</Typo>
          {isEvent && <EventTag>{strings.event}</EventTag>}
          {isRecommendProduct && <EventTag>{strings.aiCodiRecommend}</EventTag>}
        </div>
      </div>
      <div>{selected && <CheckIcon color={colors.primary3} />}</div>
    </Wrapper>
  );
}

export default FilterItem;

const Wrapper = styled.div<{ $selected: boolean }>`
  padding: 0 24px;
  min-height: 48px;
  display: flex;
  align-items: center;
  cursor: pointer;
  background: ${(props) => {
    if (props.$selected) return colors.greyHover;
    return 'white';
  }};
  font-weight: ${(props) => {
    if (props.$selected) return 700;
    return 500;
  }};
`;

export const EventTag = styled.span`
  background: #fef9c3;
  color: #854d0e;
  padding: 2px 6px;
  font-weight: 500;
  font-size: 12px;
  border-radius: 2px;
`;
